exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-field-hint[data-v-187a7974] {\n    font-size: 90%;\n    margin-top: 5px;\n    text-transform: none;\n    font-style: italic;\n    color: #6967CE;\n}\n", ""]);

// exports
